import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const InvestorPrivateRoute = () => {
  let isAuthenticated = false;
  try {
    const session = sessionStorage.getItem("aman-investor");
    if (session) {
      const parsed = JSON.parse(session);
      if (parsed && parsed.token && parsed.user) {
        isAuthenticated = true;
      }
    }
  } catch (e) {
    isAuthenticated = false;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/portal-login" replace />;
};

export default InvestorPrivateRoute;
